import { SearchInput } from 'pg-ui-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Arrow from 'src/assets/arrow-left-black.svg';
import useDebounce from 'src/hooks/useDebounce';
import EnrollmentTable from '../enrollment-table';
import {
  Container,
  Header,
  HeaderTitle,
  Content,
  HeaderItemLeft,
  NavTextLink,
  ArrowBack,
  CardItemContainer,
  CardHeaderWithButton,
  HeaderText,
  ActionsContainer,
} from './styles';

const EnrollmentHistoric: React.FC = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  // Debounce the search term so that we only perform the search
  // after the user has stopped typing for 500ms
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  return (
    <Container>
      <Header>
        <HeaderItemLeft>
          <NavTextLink to="/benefits">
            <ArrowBack src={Arrow} />
          </NavTextLink>
          <HeaderTitle>{t('benefits.enrollmentHistory.title')}</HeaderTitle>
        </HeaderItemLeft>
      </Header>
      <Content>
        <CardItemContainer>
          <CardHeaderWithButton>
            <HeaderText>{t('benefits.enrollmentHistory.title')}</HeaderText>
            <ActionsContainer>
              <SearchInput
                value={searchTerm}
                placeholder="Search..."
                handleChange={event => {
                  setSearchTerm(event.target.value);
                }}
              />
            </ActionsContainer>
          </CardHeaderWithButton>

          <EnrollmentTable searchTerm={debouncedSearchTerm} />
        </CardItemContainer>
      </Content>
    </Container>
  );
};

export default EnrollmentHistoric;
